module.exports = __webpack_public_path__ + "static/media/LOGO@2x.0488439a.png";